Object.defineProperty(exports, "__esModule", {
  value: true
});

var _airbnbPropTypes = require('airbnb-prop-types');

exports['default'] = (0, _airbnbPropTypes.childrenHavePropXorChildren)('href');


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/tab.js
// module id = 124
// module chunks = 923280921217 19843951674672